import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isRowSelected',
  pure : false
})
export class IsRowSelectedPipe implements PipeTransform {

  transform(value: Array<any> | undefined | null , index : number , key : string): boolean {
    if(value){
      return value.some((item:any) => item[key] === index );
    }
    return false;
  }

}
